// returns a Promise that returns the after hours policy
// first checks for it on the reservation
// then checks for it on specific locations
import RESERVATIONS from 'constants/reservations';
import { locationInfoById } from 'actions/location';

export const getAfterHoursPolicy =
  ({ policies, afterHoursReturn, afterHoursPickup, pickupLocation, returnLocation }) =>
  (dispatch) => {
    let afterHoursPolicyContent = policies?.find((policy) => policy.code === RESERVATIONS.POLICY_CODES.AFHR)?.content;

    if (afterHoursPolicyContent) {
      return Promise.resolve(afterHoursPolicyContent);
    }
    // if there's no policy on the res
    // we need to fetch it from a location
    let locationId = afterHoursPickup ? pickupLocation.id : null;

    if (!locationId) {
      locationId = afterHoursReturn ? returnLocation.id : null;
    }

    if (locationId) {
      return dispatch(locationInfoById(locationId)).then(({ location }) => {
        afterHoursPolicyContent = location.policies?.find(
          (policy) => policy.code === RESERVATIONS.POLICY_CODES.AFHR
        )?.policy_text;
        return afterHoursPolicyContent;
      });
    }

    return Promise.resolve(null);
  };
